"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConsensusAssembler = void 0;
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
const consensus_types_1 = require("../consensus.types");
class ConsensusAssembler {
    assemble(triaged, spec, totalReviewers) {
        const groups = this.groupByRow(triaged);
        return {
            table: this.materializeTable(groups, spec),
            annotations: triaged,
            reviewPlan: this.buildReviewPlan(groups, spec),
            autoAcceptAll: triaged.length > 0 && triaged.every((tally) => tally.triagePath === consensus_types_1.TriagePath.AutoAccept),
            totalReviewers,
        };
    }
    groupByRow(triaged) {
        const groups = [];
        const byKey = new Map();
        for (const tally of triaged) {
            const { rowKey } = tally.anchor;
            let group = byKey.get(rowKey);
            if (!group) {
                group = { rowKey, membership: undefined, fields: new Map() };
                byKey.set(rowKey, group);
                groups.push(group);
            }
            if (tally.anchor.kind === consensus_types_1.AnchorKind.Row) {
                group.membership = tally;
            }
            else {
                group.fields.set(tally.anchor.column, tally);
            }
        }
        return groups;
    }
    materializeTable(groups, spec) {
        const rows = [];
        for (const group of groups) {
            const representative = group.membership?.candidates[0]?.value;
            const base = this.toRecord(representative);
            if (group.fields.size === 0) {
                if (representative !== undefined) {
                    rows.push(spec.canonicalizeKeys(base));
                }
                continue;
            }
            for (const [column, field] of group.fields) {
                base[column] = this.resolveCell(field);
            }
            rows.push(spec.canonicalizeKeys(base));
        }
        return spec.fromRows(rows);
    }
    toRecord(value) {
        return value !== null && typeof value === 'object' ? { ...value } : {};
    }
    resolveCell(field) {
        if (field.triagePath === consensus_types_1.TriagePath.AutoAccept) {
            return field.resolved;
        }
        return this.plurality(field.candidates).value;
    }
    plurality(candidates) {
        let max = -1;
        let winners = [];
        for (const candidate of candidates) {
            if (candidate.voteCount > max) {
                max = candidate.voteCount;
                winners = [candidate];
            }
            else if (candidate.voteCount === max) {
                winners.push(candidate);
            }
        }
        if (winners.length === 1) {
            return { value: winners[0].value, tie: false };
        }
        const firstSorted = [...winners].sort((a, b) => sigma_engine_shared_1.Utils.naturalStringSort(a.normalizedValue, b.normalizedValue))[0];
        return { value: firstSorted?.value, tie: true };
    }
    buildReviewPlan(groups, spec) {
        const items = [];
        for (const group of groups) {
            const { membership } = group;
            if (spec.membershipContestable && membership && membership.triagePath === consensus_types_1.TriagePath.ExpertReview) {
                items.push({
                    anchor: membership.anchor,
                    question: consensus_types_1.ReviewQuestion.ShouldExist,
                    suggestedValues: this.toSuggestedValues(membership.candidates),
                });
            }
            for (const field of group.fields.values()) {
                if (field.triagePath !== consensus_types_1.TriagePath.AutoAccept) {
                    items.push(this.specifyValueItem(field));
                }
            }
        }
        return items;
    }
    toSuggestedValues(candidates) {
        return candidates.map((candidate) => ({
            value: candidate.value,
            voteCount: candidate.voteCount,
            confidence: candidate.confidence,
            confidenceRationale: candidate.confidenceRationale,
        }));
    }
    specifyValueItem(field) {
        return {
            anchor: field.anchor,
            question: consensus_types_1.ReviewQuestion.SpecifyValue,
            suggestedValues: this.toSuggestedValues(field.candidates),
        };
    }
}
exports.ConsensusAssembler = ConsensusAssembler;
//# sourceMappingURL=consensus-assembler.js.map